import { Network } from '@capacitor/network';
import {
  IonItem,
  IonLabel,
  IonList,
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import CCPage from '../../components/CCPage';
import { Page } from '../../interfaces/Page';
import routePaths from '../../lib/routePaths';
import { translateProp } from '../../lib/utils';
import { useStoreState } from '../../store';

const Resources: React.FC = () => {
  const { pagesByCategoryId } = useStoreState((state) => state.pages);
  const { language } = useStoreState((state) => state.translations);
  const [networkStatus, setNetworkStatus] = useState(false);
  const [resourcePages, setResourcePages] = useState<Page[]>([]);

  const getNetworkStatus = () => {
    Network.getStatus().then((status) => {
      setNetworkStatus(status.connected);
    });
  };

  useEffect(() => {
    getNetworkStatus();
  }, []);

  useEffect(() => {
    let pages: Page[] = [];

    if (networkStatus) {
      // Get pages from store when online
      pages = pagesByCategoryId.get(3) || [];
    } else {
      // Get pages from localStorage when offline
      const itemsStored = localStorage.getItem('pages');
      if (itemsStored) {
        const allPages = JSON.parse(itemsStored);
        pages = allPages.filter((page: Page) => page.navbar_category === 3);
      }
    }

    setResourcePages(pages);
  }, [networkStatus, pagesByCategoryId]);

  const resourcesContent = (
    <IonList>
      {resourcePages.length > 0 ? (
        resourcePages.map((page: Page) => (
          <IonItem
            key={page.id}
            routerLink={routePaths.public.page.replace(':slug', page.slug || '')}
            routerDirection="forward"
            lines="none"
            detail
            button
          >
            <IonLabel>
              <h2>{translateProp(page, 'navbar_title', language)}</h2>
            </IonLabel>
          </IonItem>
        ))
      ) : (
        <IonItem lines="none">
          <IonLabel>
            <p>
              <FormattedMessage id="loading-ellipsis" />
            </p>
          </IonLabel>
        </IonItem>
      )}
    </IonList>
  );

  return (
    <CCPage
      content={resourcesContent}
      title="Resources"
    />
  );
};

export default Resources;
